import { render } from "./UsersMfaAndLocation.vue?vue&type=template&id=95c5b412"
import script from "./UsersMfaAndLocation.vue?vue&type=script&lang=js"
export * from "./UsersMfaAndLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__